import React from 'react';
import styled from 'styled-components';
import { Button, Spin } from 'antd';

const StyledButton = styled(Button)`
  background: ${props => props.disabled ? '#F3F4F6' : '#4F46E5'};
  color: ${props => props.disabled ? '#9CA3AF' : 'white'};
  border: none;
  border-radius: 4px;
  padding: 4px 16px;
  height: 32px;
  margin-left: 20px;

  &:hover {
    background: ${props => props.disabled ? '#F3F4F6' : '#3C3AAE'};
    color: ${props => props.disabled ? '#9CA3AF' : 'white'};
    border: none;
  }

  position: relative;
  min-width: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  
  .loading-container {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .ant-spin {
    margin-right: 4px;
  }

  &:disabled {
    background: #f5f5f5;
    border-color: #d9d9d9;
    color: rgba(0, 0, 0, 0.25);
    cursor: not-allowed;
  }
`;

const ViewReportButton = ({
  onClick,
  disabled,
  loading,
  endTime,
  loadingId,
  id,
  'aria-label': ariaLabel
}) => {
  const isAvailable = true;
  const isThisButtonLoading = loading && loadingId === id;
  return (
    <StyledButton
      onClick={onClick}
      disabled={disabled || isThisButtonLoading}
      aria-label={ariaLabel}
    >
      {isThisButtonLoading ? (
        <div className="loading-container">
          <Spin size="small" />
          <span>Generating PDF...</span>
        </div>
      ) : isAvailable ? (
        'View Report'
      ) : (
        'Not Available'
      )}
    </StyledButton>
  );
};

export default ViewReportButton;